import axios from 'axios'
import {getToken} from '../../config/cache'
import router from '../../config/router'

class Http {
    constructor() {
        this.inited = false;
    }

    //初始化参数
    // {
        //     baseURL: 'http://127.0.0.1:7001/', // api的base_url
        //     timeout: 5000 // request timeout
        // }
    init(params) {
        
        this.http = axios.create(params);
        //请求处理
        this.http.interceptors.request.use(config => {
            const token = getToken()//获取本地token
            if (token) {
                config.headers.Authorization = token// 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
            }
            return config
        }, error => {
            Promise.reject(error)
        })
        //返回处理
        this.http.interceptors.response.use(
            response => {
                console.log('111');
                const res = response.data
                if (res.code === 422 || res.code == 401 || res.code == 403) {
                    console.log("msg:", res.message);

                }
                // return JSON.parse(response.data);
                return response.data;
            },
            error => {
                console.log("222", error);
                    router.push({path:'/login'});
                // return Promise.reject(error)
            })

        this.inited = true;

    }

    get(action, params) {
        if(!this.inited)
        {
            console.log('请先初始化网络请求器....');
            return
        }
        return this.http({
            url: action,
            method: 'GET',//method.toUpperCase(),
            params: params
        })
    }

    post(action, params) {
        if(!this.inited)
        {
            console.log('请先初始化网络请求器....')
            return;

        }
        return this.http({
            url: action,
            method: 'POST',//method.toUpperCase(),
            data: params
        })
    }

    put(action,params)
    {
        if(!this.inited)
        {
            console.log('请先初始化网络请求器....')
            return;

        }
        return this.http({
            url: action,
            method: 'PUT',//method.toUpperCase(),
            data: params
        })
    }

    delete(action,params)
    {
        if(!this.inited)
        {
            console.log('请先初始化网络请求器....')
            return;

        }
        return this.http({
            url: action,
            method: 'DELETE',//method.toUpperCase(),
            data: params
        })
    }

}

export default new Http();